module.exports = __webpack_public_path__ + "static/media/Свидетельство ООО МКК КАПЕЛЛА.239bb316.jpg";